module.exports = __webpack_public_path__ + "assets/img/center.a01e02ec.png";